import { Amplify } from "aws-amplify";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import App from "./App";
import "@cloudscape-design/global-styles/index.css"
import { AuthProvider } from "./context/AuthContext";
import { UserRelationsProvider } from './context/UserRelationsContext.tsx';
import { CraftRoomProvider } from './context/CraftRoomContext';
import { authConfig } from './config/auth';

Amplify.configure({
  Auth: authConfig,
});


// Render App
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <AuthProvider>
      <UserRelationsProvider>
        <CraftRoomProvider>
          <App />
        </CraftRoomProvider>
      </UserRelationsProvider>
    </AuthProvider>
  </BrowserRouter>
);
